import { FormatStringByWordLength, DoArraysOverlap, Split, Join } from "../../../shared/scripts/array-functions";
export class StudyListingDto {
    Id: number;
    Name: string;

    constructor() { }

    initialize(): void { }

    matchesFilter(study: any): boolean {
        // Study filter
        if (study && study.length > 0 && !study.includes(this.Name)) return false;
        return true;
    }
}